import useNotification from '@/hooks/useNotification';
import React, { useEffect, useState } from 'react';
import Button from './Button';

interface ShareButtonProps {
  borderColor?: string;
  textColor?: string;
  url?: string;
}

export default function ShareButton({ borderColor, textColor, url }: ShareButtonProps) {
  const { showNotification } = useNotification();
  const [currentUrl, setCurrentUrl] = useState(url ?? '');

  useEffect(() => {
    if (!url) {
      setCurrentUrl(window.location.href); //support ssr
    }
  }, []);

  const handleButtonClick = () => {
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        showNotification(
          {
            message: `URL copied to clipboard!`,
            emoji: '🔔',
          },
          3000
        );
      })
      .catch(() => {
        showNotification(
          {
            message: `'Failed to copy:`,
          },
          3000
        );
      });
  };
  return (
    <Button
      type="secondary"
      onClick={handleButtonClick}
      className={`${textColor} border-${borderColor}`}
    >
      SHARE
    </Button>
  );
}
